import styles from './cookieBanner.module.scss';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { useMemo, useState } from 'react';

const CookieBanner = () => {
    const { t } = useTranslation();

    const isCookieAccepted = useMemo(() => localStorage.getItem('isCookieAccepted') === 'true', []);
    const [isVisible, setIsVisible] = useState(!isCookieAccepted);

    const handleAcceptClick = () => {
        setIsVisible(false);
        localStorage.setItem('isCookieAccepted', 'true');
    };

    const handleDeclineClick = () => {
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div className={styles.root}>
            <div className={styles.column}>
                <Typography className={styles.text}>{t('HeadsUp')}</Typography>
            </div>
            <div className={clsx(styles.column, styles.rightColumn)}>
                <Typography className={styles.text}>{t('TheWebsiteUsesCookies')}</Typography>
                <div className={styles.buttons}>
                    <Typography
                        className={clsx(styles.text, styles.acceptButton, styles.clickableButton)}
                        onClick={handleAcceptClick}>
                        {t('Accept')}
                    </Typography>
                    <Typography
                        className={clsx(styles.text, styles.clickableButton)}
                        onClick={handleDeclineClick}>
                        {t('Decline')}
                    </Typography>
                </div>
            </div>
        </div>
    );
};

export default CookieBanner;
